import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import { updateProfileRoutine } from '../../routines';
import { updateProfile, checkUserEmail } from '../../../../services/userService';

function* updateProfileReq({ payload }: Routine<any>) {
  try {
    if (payload.email) {
      const { isEmailUsed } = yield call(checkUserEmail, { email: payload.email, checkMe: true });

      if (isEmailUsed) {
        yield put(updateProfileRoutine.failure({
          intlId: 'emailIsUsed',
          message: 'Email is already in use',
          isEmailUsed
        }));
        return;
      }
    }

    const data = yield call(updateProfile, payload);
    yield put(updateProfileRoutine.success(data));
  } catch (error) {
    yield put(updateProfileRoutine.failure({ errorIntlId: error.message }));
  }
}

function* watchUpdateProfileReq() {
  yield takeEvery(updateProfileRoutine.TRIGGER, updateProfileReq);
}

export default function* profileSaga() {
  yield all([watchUpdateProfileReq()]);
}
